import { prune } from "./serializer";

export default class Persistable {
    toJSON(includedProps = [], excludedProps = []) {
        return prune(this, includedProps, excludedProps);
    }

    fromJSON() {}
}
